import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
import { Modal } from "react-responsive-modal";
import { NewInputText, SelectBoxMUiInputComponent } from '../../../../reusableComponents/inputReusableComponent/InputBoxComponent'
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const reasonData = [
    { id: 1, name: "Event has been cancelled", value: "Event has been cancelled" },
    { id: 2, name: "Event has been postponed", value: "Event has been postponed" },
    { id: 3, name: "Other", value: "Other" }
];

const refundType = [
    { id: 1, name: "Full", value: "Full" },
    { id: 2, name: "Custom", value: "Custom" }
]

const ExpRejectionModal = ({ modal, setModal, onCancel, type, ...props }) => {
    const history = useHistory();

    const [state, setState] = useState({
        open: false,
        cancelReservationData: "",
        refundType: "",
        refundPercentage: 100,
        enterReason: "",
        errors: {},
    });

    const [confirm, setConfirm] = useState(false);


    return (
        <div>
            {!confirm ?
                <Modal
                    open={modal === "PENDING" ? true : false}
                    onClose={() => setModal("")}
                    center
                    classNames={{
                        overlay: "customOverlay-request-accept-cancelled",
                        modal: "small-popup",
                        animationIn: "customEnterAnimation",
                        animationOut: "customLeaveAnimation",
                    }}
                    animationDuration={1000}
                >
                    <div className="reusable-popup-header-newstyle">
                        <h4>
                            {"Request Cancel"}
                        </h4>
                        <p className="text-left mt-2"> Are you sure to Cancel ?</p>
                    </div>
                    <div className="reason-for-cancellation p-0">
                        <div className="mt-5 d-flex">
                            <ReusableOnboardingButton
                                buttonTitle="No"
                                buttonClass={
                                    "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                                }
                                buttonText="No"
                                onClick={() => setModal("")}
                                buttonType="button"
                            />
                            <ReusableOnboardingButton
                                buttonTitle="Yes"
                                buttonClass={
                                    "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                }
                                buttonText="Yes"
                                onClick={() => setConfirm(true)}
                                buttonType="button"
                            />
                        </div>
                    </div>
                </Modal>
                : <Modal
                    open={modal === "PENDING" ? true : false}
                    onClose={() => setModal("")}
                    center
                    classNames={{
                        overlay: "customOverlay-request-accept-cancelled",
                        modal: "small-popup",
                        animationIn: "customEnterAnimation",
                        animationOut: "customLeaveAnimation",
                    }}
                    animationDuration={1000}
                >
                    <div className="reusable-popup-header-newstyle">
                        <h4>
                            {history.location.pathname.includes('admin') ? "Reason for Cancellation" : "Reason for Rejection"}
                        </h4>
                    </div>
                    <div className="reason-for-cancellation p-0">
                        <Form>
                            <div className="mt-4">
                                <SelectBoxMUiInputComponent
                                    extraClass={false}
                                    selectLabel="Select Reason"
                                    name="cancelReservationData"
                                    value={state.cancelReservationData}
                                    onChange={(e) => setState({ ...state, cancelReservationData: e.target.value })}
                                    getData={reasonData}
                                    errorText={state?.errors?.cancelReservationData}
                                    errorTrue={state?.errors?.cancelReservationData === "" ? true : false}
                                />
                            </div>
                            {state.cancelReservationData === "Other" ? (
                                <NewInputText
                                    name="enterReason"
                                    onChange={(e) => setState({ ...state, enterReason: e.target.value })}
                                    rows="4"
                                    multiline={true}
                                    value={state.enterReason}
                                    labelText="Enter Reason"
                                    controlClass={"outlined-helperText "}
                                />
                            ) : null}
                            {type === "CANCEL" ?
                                <>
                                    <div className="mt-4">
                                        <SelectBoxMUiInputComponent
                                            extraClass={false}
                                            selectLabel="Select Refund Type"
                                            name="refundType"
                                            value={state.refundType}
                                            onChange={(e) => setState({ ...state, refundType: e.target.value })}
                                            getData={refundType}
                                            errorText={state?.errors?.refundType}
                                            errorTrue={state?.errors?.refundType === "" ? true : false}
                                        />
                                    </div>
                                    {state.refundType === "Custom" ? (
                                        <NewInputText
                                            name="refundPercentage"
                                            onChange={(e) => setState({ ...state, refundPercentage: e.target.value })}
                                            value={state.refundPercentage}
                                            labelText="Enter Refund Percentage"
                                            controlClass={"outlined-helperText "}
                                        />
                                    ) : null}
                                </> : <></>
                            }
                            <div className="mt-5 d-flex">
                                <ReusableOnboardingButton
                                    buttonTitle="Cancel Button"
                                    buttonClass={
                                        "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                                    }
                                    buttonText="Cancel"
                                    onClick={() => setModal("")}
                                    buttonType="button"
                                />
                                <ReusableOnboardingButton
                                    buttonTitle="Save"
                                    buttonClass={
                                        state.cancelReservationData === "" ||
                                            (state.cancelReservationData === "Other" &&
                                                state.enterReason === "")
                                            ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                                            : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                    }
                                    buttonText="Save"
                                    onClick={() => onCancel(state.enterReason || state.cancelReservationData, state.refundPercentage)}
                                    buttonType="button"
                                />
                            </div>
                        </Form>
                    </div>
                </Modal>}
        </div>
    )
}

export default ExpRejectionModal;
